
import React , {  Children, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { GrClose, GrSearch } from "react-icons/gr";
import { GiHamburgerMenu } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { setLang, setSelected } from "../store/reducers/CartReducer";
import { Footer } from "./Footer";
export const  Header = () => {


  const [showMenu, setShowMenu] = useState(false);

  const [whats, setWhats] = useState(false);

  const handleClose = () => {setShowMenu(false)
    
  }

  
  const setLang_ = () => {
    dispatch(setLang())
    if(lang === 'ar'){
      localStorage.setItem('lang','en')
    }else{
      localStorage.setItem('lang','ar')
    }
  }
 
const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
  

}, []);


useEffect(() => {
  setTimeout(() => {
   
   }, 1000)
}, []);

var lang = useSelector((state) => state.cart.lang);

const dispatch = useDispatch();





const navLinks = [
  {
    id: "/",
    title:  lang === 'en' ?  "Home" : " الرئيسية ",
    Children:[]
  },

  
  {
    id: "Products",
    title:  lang === 'en' ? "Products" : "المنتجات",
    Children:[]
  },
  {
    id: "Brands",
    title:  lang === 'en' ? "Brands" : "الوكالات",
    Children:[]
  },
  {
    id: "About",
    title:  lang === 'en' ? "About" : " من نحن",
    Children:[]
  },
  {
    id: "Contact",
    title:  lang === 'en' ? "Contact" : "تواصل",
    Children:[]
  },
];


const selected =  useSelector((state) => state.cart.selected) ;

const setSelected_ = (value)=>{
  dispatch(setSelected({select:value}))
} 


const [visible, setVisible] = useState(false) 

const toggleVisible = () => { 
  const scrolled = document.documentElement.scrollTop; 
  if (scrolled > 50){ 
    setVisible(true) 
    setWhats(true);
  }  
  else{ 
    setVisible(false) 
  } 
}; 

window.addEventListener('scroll', toggleVisible); 




const [visible1, setVisible1] = useState(false) 

  return (
    <div ><header dir={lang === 'en' ? 'ltr' : 'rtl'} style={{zIndex:1000}} className= {`fixed h-[80px] w-full flex flex-row items-center justify-between sm:justify-around p-2  ${visible ? 'bg-[#ffffff]/95 text-black ': 'transparent text-white' } `}>
    <Link 
     onClick={()=>{
      setSelected_(0)
      handleClose()
      window.scrollTo(0, 0)
      }} 
    to="/"
    className="flex items-center  hover:opacity-70 ">
    <img className="w-[30px] md:w-[40px] lg:w-[45px] xl:w-[50px]" src="/logo.svg" alt="Al-hubaishi"/>
    <h1
   
    style={{textAlign:'center',fontFamily:'CairoExtraBold'}}
    
      className="text-primary text-[25px]  md:text-[35px] lg:text-[40px] xl:text-[45px] "
    >
   {lang==='en' ? 'Al-Hubaishi' : 'الحبيشي'}
      
      </h1>
</Link>


{width < 800 ?

  <>

 
 

  <div  className="flex gap-4">
{/*<button  className="flex items-center text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]" >
<GrSearch className="m-auto" />
</button>*/}





      <button
     id="show"
      aria-label="menu"
        onClick={() => setShowMenu(!showMenu)}
        className=" text-zinc-500 hover:text-gray-500"
      >
        {showMenu ? <GrClose className="mt-5" size={25} /> : <GiHamburgerMenu size={25} />}
   


       
{ showMenu ? 
        <>
      <div className="dropdown ">



  <div  className={`dropdown-content text-zinc-500 ${lang === 'en' ? "right-[25px]" : "left-[25px]"}`}>

  {navLinks.map((item,i)=>
<>
<br></br>
<Link key={i}  style={{fontFamily:'CairoBold'}} onClick={()=>{
handleClose()
setSelected_(i)
  }}  aria-label={item.title} className={`${selected === i ? 'text-primary' : 'hover:opacity-70' } `} to={item.id} >{item.title}</Link>



<br></br>
</>
)}



  </div>

  </div>
  </>
  
   :''
     
      }
      </button>
      <button
        onClick={() => {setLang_()}}
       style={{fontFamily:'CairoBold'}}
       className={`${showMenu ?  'mt-[19px]' :''} text-zinc-500  hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]`}
          aria-label="language"
      >
{lang === 'en' ? 'AR' : 'EN'}
      </button>

      </div>
</>
:


<>
<nav dir={`${lang === 'en' ? 'ltr' : 'rtl'}`}  className=" flex justify-between items-center text-zinc-500  gap-3 ">

{navLinks.map((item,i)=>

  <Link  aria-label={item.title} key={i} onClick={()=>{
handleClose()
setSelected_(i)
  }} style={{fontFamily:'CairoBold'}}  className={`${selected === i ? 'text-primary' : 'hover:opacity-70' } `}  to={item.id} >{item.title}</Link>


)} 

   </nav>
    
<div className="flex gap-4">
{/*<button  className="flex items-center text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]" >
<GrSearch className="m-auto" />
</button>*/}

<button
           onClick={() => {setLang_()}}
       style={{fontFamily:'CairoBold'}}
       className="text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]"
          aria-label="language"
      >
{lang === 'en' ? 'Ar' : 'EN'}
      </button>

</div>
   </> 
}
 

  </header>

{
<a style={{zIndex:100}} className= {`${whats ? 'opacity-[1]' : 'opacity-[0]'}  transition-all transition-discrete duration-500 fixed bottom-[5%] ${lang === 'en' ? 'right-[20px]' : ' left-[20px]'}`}  target='__blink' href="https://wa.me/+967779030000" >
  <img width='50px' height='50px' src="https://alhubaishi.future-swift.com/img/WhatsApp.png" alt="AlHubaishi WhatsApp"  />
</a>
}


<Outlet />


<Footer lang={lang} />
  
</div>
   
  );
}
